module.exports = __webpack_public_path__ + "img/West-Mermis-300x300.c09df833.png";